import { CONFIG } from './config.mjs';
import { state, aiImages, aiBgElements, pictureElements } from './state.mjs';
import { init } from './init.mjs';
import { invalidateMeasurementCache } from '../utils/cache.mjs';
import { detectFormats } from '../detection/detect-formats.mjs';
import { imageTransform } from '../processors/image-transform.mjs';
import { backgroundTransform } from '../processors/background-transform.mjs';
import { pictureTransform } from '../processors/picture-transform.mjs';
import { imageUpdate } from '../processors/image-update.mjs';

/**
 * API publique du système AdaptiveImages
 */
export const AdaptiveImages = {
    async init() {
        try {
            await init();
        } catch (error) {
            console.error('[AI] Erreur lors de l\'initialisation:', error);
        }
    },

    async refresh() {
        invalidateMeasurementCache();

        const newPictureElements = Array.from(document.querySelectorAll('picture'));
        const newImages = Array.from(document.querySelectorAll('img[ai-src]'));
        const newBgElements = Array.from(document.querySelectorAll('[ai-bg-src]'));

        if (newPictureElements.length) {
            // Mise à jour de la variable globale
            pictureElements.length = 0;
            pictureElements.push(...newPictureElements);
            await pictureTransform();
        }

        if (newImages.length) {
            // Mise à jour de la variable globale
            aiImages.length = 0;
            aiImages.push(...newImages);
            await imageTransform();
        }

        if (newBgElements.length) {
            // Mise à jour de la variable globale
            aiBgElements.length = 0;
            aiBgElements.push(...newBgElements);
            await backgroundTransform();
        }

        imageUpdate(false);
    },

    invalidateCache() {
        invalidateMeasurementCache();
        if (CONFIG.debug) {
            console.log('[AI] Cache de mesures invalidé manuellement');
        }
    },

    setCacheDuration(duration) {
        if (typeof duration === 'number' && duration >= 0) {
            state.cacheDuration = duration;
            if (CONFIG.debug) {
                console.log(`[AI] Durée du cache définie à ${duration}ms`);
            }
        }
    },

    async getSupportedFormats() {
        return await detectFormats();
    },

    setFormatPreference(format) {
        const validFormats = ['auto', 'avif', 'webp', ''];
        if (validFormats.includes(format)) {
            CONFIG.formats.preferredFormat = format;
            state.formats = null;
            state.formatsPromise = null;
            if (CONFIG.debug) {
                console.log(`[AI] Format préféré: ${format}`);
            }
        }
    },

    setAutoDetect(enabled) {
        CONFIG.formats.autoDetect = Boolean(enabled);
        state.formats = null;
        state.formatsPromise = null;
        if (CONFIG.debug) {
            console.log(`[AI] Détection auto: ${enabled ? 'activée' : 'désactivée'}`);
        }
    }
};
